import { render, staticRenderFns } from "./DonutChartCard.vue?vue&type=template&id=3e06dc71&scoped=true"
import script from "./DonutChartCard.vue?vue&type=script&lang=js"
export * from "./DonutChartCard.vue?vue&type=script&lang=js"
import style0 from "./DonutChartCard.vue?vue&type=style&index=0&id=3e06dc71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06dc71",
  null
  
)

export default component.exports